module.exports = __webpack_public_path__ + "img/4788.fc7d41f9.svg";